import axios from "axios";

//Functions

export function login(data) {
  return axios
    .post("/api/tutor/tutor_users/login", {
      email: data.email,
      password: data.password,
      businessID: data.businessID,
    })
    .then((response) => {
      if (response.status === 200) {
        localStorage.setItem("authorization-state-tutor", "LoggedIn");
        localStorage.setItem("authorization-expire-tutor", Date.now() + 86400000);
        return response;
      } else {
        return response;
      }
    })
    .catch(() => {
      return "There was an error.";
    });
}

export function isAuthenticatedTutor() {
  //If the refresh token has expired, just log them out
  if (
    localStorage.getItem("authorization-state-tutor") &&
    localStorage.getItem("authorization-expire-tutor") < Date.now()
  ) {
    localStorage.removeItem("authorization-state-tutor");
    localStorage.removeItem("authorization-expire-tutor");
    return (window.location.href = "/");
  }
  return (
    localStorage.getItem("authorization-state-tutor") &&
    localStorage.getItem("authorization-expire-tutor") > Date.now()
  );
}

export async function tutorLogOut() {
  if (localStorage.getItem("authorization-state-tutor") !== null) {
    await axios.post("/api/tutor/tutor_users/logout");
    localStorage.removeItem("authorization-state-tutor");
    localStorage.removeItem("authorization-expire-tutor");
    return (window.location.href = "/");
  }
}
